export default __webpack_public_path__ + "static/media/2502101.a1a43197.jpg";